import React        from 'react';
import CSSModules   from 'react-css-modules';

import Button   from "../Button";
import FontIcon from "../FontIcon";
import Checkbox from "../Checkbox";

import style from "./style.scss";

import courses from "../../services/courses";

const TestimonialList = props => {

    function _isTestimonialFeatured(testimonialId) {

        const selectedCourse = props.courses.find((course) => course.id === props.selectedCourseId);

        return selectedCourse['featured_testimonial_id'] === testimonialId;
    }

    function _toggleFeaturedTestimonial(testimonialId) {

        courses.update({
            id: props.selectedCourseId,
            featured_testimonial_id: testimonialId

        }).then(props.loadCourses);
    }

    return (
        <div>

            <Button onClick={ props.showAddTestimonialForm }
                    autoWidth="true"
                    className={ style['new-testimonial-button'] }>

                <FontIcon textPosition="right" iconName="plus" />
                <span>New testimonial</span>

            </Button>

            <section className={style["testimonial-list"]}>

                {
                    props.testimonials.map((testimonial) => {

                        return (
                            <article key={ testimonial.id } className={style["testimonial"]}>

                                <div className={style["featured-testimonial-option"]}>

                                    <Checkbox value={ _isTestimonialFeatured(testimonial.id) }
                                              checked={ _isTestimonialFeatured(testimonial.id) }
                                              onChange={ _toggleFeaturedTestimonial.bind(this, testimonial.id) } />

                                    <span>Featured</span>

                                </div>

                                <h2 className={style["testimonial-author"]}>
                                    { testimonial.author_name }
                                </h2>

                                <h3 className={style["testimonial-organisation"]}>
                                    { testimonial.organisation_name }
                                </h3>

                                <div className={style["testimonial-text"]}
                                     dangerouslySetInnerHTML={{ __html: testimonial.content }}>
                                </div>

                                <div className={style["testimonial-link-panel"]}>

                                    <a onClick={ props.showEditTestimonialForm.bind(this, testimonial) }
                                       className={style["testimonial-link"]}>
                                        Edit
                                    </a>

                                    <a onClick={ props.showDeleteTestimonialOverlay.bind(this, testimonial) }
                                       className={style["testimonial-link"]}>
                                        Delete
                                    </a>
                                </div>

                            </article>
                        )
                    })
                }

            </section>

        </div>
    )
}

export default CSSModules(TestimonialList, style);


// WEBPACK FOOTER //
// ./components/TestimonialList/index.js